import script from "./goRinSyo0016.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0016.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0016.vue?vue&type=style&index=0&id=1f376abe&lang=scss"

const __exports__ = script;

export default __exports__